var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"button button4",on:{"click":_vm.submit}},[_c('img',{attrs:{"src":require("@/assets/stripe-logo.png"),"alt":"Pagar com Stripe","width":"90px"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }